import * as React from 'react';
import * as Tgcc from '../tgccGlobal'; // make sure to import the relevant methods or constants if needed

const ProgressBar = ({ currentStep, totalSteps }) => {
  const fillWidth = (currentStep / totalSteps) * 100;
  const pizzaIconSize = 30; // Size of the pizza icon
  
  const progressBarContainerStyle = {
    width: '45%', // Adjusted width to 80% of its container
    margin: '0 auto', // Center the bar within its parent container
    backgroundColor: '#e6e6e6',
    borderRadius: '10px',
    height: '10px',
    position: 'relative', // Position relative to allow absolute positioning of the pizza icon
  };
  
  const progressBarStyle = {
    width: `${fillWidth}%`,
    backgroundColor: '#4F78FE',
    height: '100%', // Filler will occupy the full height of the container
    borderRadius: 'inherit', // Inherit the border-radius from the container
    transition: 'width 0.5s ease-in-out',
  };
  
  const pizzaIconStyle = {
    position: 'absolute',
    top: '-10px', // Adjust as necessary
    left: `calc(${fillWidth}% - ${pizzaIconSize / 2}px)`, // Adjust based on the progress
    width: `${pizzaIconSize}px`,
    height: 'auto',
    zIndex: 2, // To ensure it's above the progress bar
  };

  const stepIndicatorStyle = {
    paddingTop: '5px',
    textAlign: 'center',
  };

  return (
    <div style={{ position: 'relative', height: '30px' }}> {/* Removed ...otherContainerStyles */}
      <div style={progressBarContainerStyle}>
        <div style={progressBarStyle}></div>
        {/* Conditionally render the pizza icon only if fillWidth > 0 */}
        {fillWidth > 0 && (
          <img
            src={Tgcc.ResolveUrl('~/images/PizzaSlice.svg')} // Adjust the path as necessary
            style={pizzaIconStyle}
            alt="Pizza Slice"
          />
        )}
      </div>
      <div style={stepIndicatorStyle}>
        Step {currentStep} of {totalSteps}
      </div>
    </div>
  );
};

export default ProgressBar;
